import React from 'react';
import { RenderButton } from '~button';
import Label from './Label';
import Item from './Item';
import headerPropTypes from '../../prop-types/headerPropTypes';

var Navigation = function Navigation(_ref) {
  var list = _ref.list,
      isListVertical = _ref.isListVertical,
      _onClickLinkCallback = _ref.onClickLinkCallback,
      isMobile = _ref.isMobile;

  if (!list) {
    return null;
  }

  return list.map(function (item, index) {
    var path = item.path,
        label = item.label,
        btnType = item.btnType,
        skin = item.skin,
        size = item.size,
        onClick = item.onClick,
        isExternal = item.isExternal,
        icon = item.icon;
    var renderSize = size;

    if (!size) {
      renderSize = isMobile ? 'lg' : 'default';
    }

    return /*#__PURE__*/React.createElement(Item, {
      key: index,
      isListVertical: isListVertical
    }, /*#__PURE__*/React.createElement(RenderButton, {
      path: path,
      isExternal: isExternal,
      btnType: btnType,
      size: renderSize,
      skin: skin,
      icon: icon,
      onClick: onClick,
      onClickLinkCallback: function onClickLinkCallback() {
        return _onClickLinkCallback();
      }
    }, /*#__PURE__*/React.createElement(Label, null, label)));
  });
};

Navigation.defaultProps = {
  list: null,
  isListVertical: false,
  onClickLinkCallback: function onClickLinkCallback() {}
};
export default Navigation;